import apiSettings from '../../config/api';
import request from '../../utils/request/index';
import actionTypes from './ActioTypes';

const getAllCities = () => {
  const url = apiSettings.endpoints.genGetAllCitiesUrl();
  return dispatch => {
    request
      .get(url, dispatch, actionTypes.GET_ALL_CITIES)
      .then((res) => {
        dispatch({type: actionTypes.GET_ALL_CITIES.fulfilled, data: res.data.cities})
      })
  }
};

const getCategories = () => {
  const url = apiSettings.endpoints.genGetCategoriesUrl();
  return dispatch => {
    request
      .get(url, dispatch, actionTypes.GET_CATEGORIES)
      .then((res) => {
        dispatch({type: actionTypes.GET_CATEGORIES.fulfilled, data: res.data.categories})
      })
  }
};

const onMainClick = () => {
  return dispatch => {
    dispatch({type: actionTypes.ON_MAIN_CLICK});
    setTimeout(() => dispatch({type: actionTypes.ON_MAIN_CLICK}), 20)
  }
};

const contactUs = (data) => {
  const url = apiSettings.endpoints.genContactUsUrl();
  return dispatch => {
    request
      .post(url, data, dispatch, actionTypes.CONTACT_US)
      .then((res) => {
      console.log(res);
        dispatch({type: actionTypes.CONTACT_US.fulfilled})
      })
  }
}

export {getAllCities, getCategories, onMainClick, contactUs}


// WEBPACK FOOTER //
// ./src/app/containers/Main/Actions.js